import { render } from "./DeletedMedications.vue?vue&type=template&id=5be72482&scoped=true"
import script from "./DeletedMedications.vue?vue&type=script&lang=js"
export * from "./DeletedMedications.vue?vue&type=script&lang=js"

import "./DeletedMedications.vue?vue&type=style&index=0&id=5be72482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be72482"]])

export default __exports__